import React from "react";
import { cn } from "../../lib/utils";

const STATUS_STYLES = {
  ausstehend: "bg-status-ausstehend-bg text-status-ausstehend-text border-status-ausstehend-border",
  aktiv: "bg-status-aktiv-bg text-status-aktiv-text border-status-aktiv-border",
  abgelehnt: "bg-status-abgelehnt-bg text-status-abgelehnt-text border-status-abgelehnt-border",
};

const STATUS_LABEL = {
  ausstehend: "Ausstehend",
  aktiv: "Aktiv",
  abgelehnt: "Abgelehnt",
};

export function StatusBadge({ status, className, ...props }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs font-medium tracking-wide",
        STATUS_STYLES[status] || "bg-ink-100 text-ink-700 border-ink-300",
        className
      )}
      {...props}
    >
      <span
        className={cn(
          "mr-2 inline-block h-1.5 w-1.5 rounded-full",
          status === "ausstehend" && "bg-status-ausstehend-border animate-pulse",
          status === "aktiv" && "bg-status-aktiv-border",
          status === "abgelehnt" && "bg-status-abgelehnt-border"
        )}
      />
      {STATUS_LABEL[status] || status}
    </span>
  );
}
